

// ページ内アンカーリンクのスクロールエフェクト
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定)
jQuery(function($) {
    var headerHeight = 0; // ヘッダー追従でない場合
	// var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合
    $('a[href^="#"]').click(function(){
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        if ( target.length > 0 ) {
            var position = target.offset().top - headerHeight;
            $("html, body").animate({scrollTop:position}, 550, "swing");
            return false;
        }
    });
})

// ブログサムネイル 中心でトリミング
jQuery(function($) {
    if ( $('.obj_image').length > 0 ) {
        objectFitImages('.obj_image');
    }
});




// レスポンシブ画像切り替え imgにclass「js-image-switch」
jQuery(function($) {

	if ( $('.js-image-switch').length > 0 ) {

		var $elem = $('.js-image-switch');
		var sp = '_sp.';
		var pc = '_pc.';
		// 画像を切り替えるウィンドウサイズ
		var replaceWidth = 768;

		function imageSwitch() {
			var windowWidth = parseInt($(window).width());
			$elem.each(function() {
				var $this = $(this);
				if(windowWidth >= replaceWidth) {
				$this.attr('src', $this.attr('src').replace(sp, pc));
				} else {
					$this.attr('src', $this.attr('src').replace(pc, sp));
				}
			});
		}
		imageSwitch();

		var resizeTimer;
		$(window).on('resize', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				imageSwitch();
			}, 200);
		});
	}
});



// ドロワーメニュー
jQuery(function($) {
    if ($('#toggle').length > 0) {
		$('#toggle').click(function () {
			$(this).toggleClass('toggle_active');
			$('#drawer_layer').fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				$('nav').addClass('is_open');
				$('nav').removeClass('is_close');
			} else {
				$('nav').removeClass('is_open');
				$('nav').addClass('is_close');
			}
		});

		$('#drawer_layer').click(function () {
			$(this).fadeOut();
			$('#toggle').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			$('nav').removeClass('is_open');
			$('nav').addClass('is_close');
		});

		// エリア内リンク用
		$('nav a').on('click', function(){
			// if (window.innerWidth <= 768) {
			if ($('#toggle:visible').length > 0) {
				$('#toggle').click();
			}
		});
	}

});


jQuery(function($) {
	//sort device function
	var getDevice = (function(){
		var ua = navigator.userAgent;
		if(ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0){
				return 'sp';
		}else{
				return 'other';
		}
	})();

	// Scrolled Animation
	$(function () {

	// animationの記述有無確認
	if($('.ani_bottom').length){
		//発火タイミング +
		var scrollPlus=50;
		var sp = false;
		if(getDevice=='sp'){
			scrollPlus=0;
			sp = true;
		}

		var windowHeight = $(window).height(); //ウインドウの高さを取得
		var scrollPosition = $(this).scrollTop();
		$(".ani_bottom").each(function(){
			var position = $(this).offset().top; //ページの一番上から要素までの距離を取得
			if (scrollPosition > position - windowHeight + scrollPlus){ //スクロール位置が要素の位置を過ぎたとき
				$(this).addClass('ani_on'); //クラス「active」を与える
			}
		});

		$(window).scroll(function() {

			var scrollPosition = $(this).scrollTop();

			$(".ani_bottom").each(function(){
				var position = $(this).offset().top; //ページの一番上から要素までの距離を取得
				if (scrollPosition > position - windowHeight + scrollPlus){ //スクロール位置が要素の位置を過ぎたとき
					$(this).addClass('ani_on'); //クラス「active」を与える
				}
			});

		});
	}
	})
});
